import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'eco-job-status-placeholder',
    templateUrl: './job-status-placeholder.component.html',
    styleUrls: ['./job-status-placeholder.component.scss'],
    imports: [MatIcon]
})
export class JobStatusPlaceholderComponent {
    @Input() type: 'success' | 'error' = 'success';
    @Input() title = 'Success';
    @Input() subtitle = '';

    getTypeIcon(): string {
        switch (this.type) {
            case 'success':
                return 'task_alt';
            case 'error':
                return 'sentiment_very_dissatisfied';
        }
    }
}
